// extracted by css-extract-rspack-plugin
export default {"PreviewLabel":"RepoPullsDashboardHeader-module__PreviewLabel__hN1P4","SidebarDivider":"RepoPullsDashboardHeader-module__SidebarDivider__xp5lY"};